import React, { useState } from "react";
import { TextField } from "@mui/material";

interface PhoneNumberInputProps {
  value: string;
  onChange: (maskedValue: string, unmaskedValue: string, name: string) => void;
  placeholder?: string;
  label?: string;
  name: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  placeholder = "Ex: (99) 99999-9999",
  label,
  name
}) => {

  const [error, setError] = useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    // Remove qualquer caractere que não seja número
    const unmaskedValue = inputValue.replace(/\D/g, "");

    // Adicionar máscara
    let maskedValue = unmaskedValue;
    if (unmaskedValue.length > 0) {
      maskedValue = `(${unmaskedValue.slice(0, 2)}`;
      if (unmaskedValue.length > 2) {
        maskedValue += `) ${unmaskedValue.slice(2, 7)}`;
      }
      if (unmaskedValue.length > 7) {
        maskedValue += `-${unmaskedValue.slice(7, 11)}`;
      }
    }

    // Atualizar valor no componente pai
    onChange(maskedValue, unmaskedValue, name);

    setError(unmaskedValue.length < 10 || unmaskedValue.length > 11);
  };

  return (
    <TextField
      size="small"
      name={name}
      required
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={handleInputChange}
      error={error}
      helperText={error ? "Número inválido. Deve conter 10 ou 11 dígitos." : ""}
      inputProps={{ maxLength: 15 }}
      fullWidth
      InputLabelProps={{ shrink: true }}
    />
  );
};

export default PhoneNumberInput;
